angular.module('autoremind.admin.chargify')
    .factory('chargifyService', ['$enhancedHttp', '$timeout', '$q', function ($enhancedHttp, $timeout, $q) {
        return {
            loadingIndicator: {
                refCount: 0,
                state: true
            },
            communicationBillingList: [],
            customersCount: 0,
            selectedDate: null,
            fetchProductList: function () {
                var servletUrl = '/servlets/chargify/product/list/';
                return $enhancedHttp({
                    method: 'GET',
                    url: servletUrl
                }, this.loadingIndicator);
            },
            fetchAccount: function (userName) {
                var servletUrl = '/servlets/chargify/account/username/' + userName + '/';
                return $enhancedHttp({
                    method: 'GET',
                    url: servletUrl
                }, this.loadingIndicator);
            },
            fetchSubscriptionsReconcile: function () {
                var servletUrl = '/servlets/chargify/subscriptions/reconcile/';
                return $enhancedHttp({
                    method: 'GET',
                    url: servletUrl
                }, this.loadingIndicator);
            },
            customerSetReference: function (customerId, data) {
                var servletUrl = "/servlets/chargify/customerupdate/id/" + customerId + "/";
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: servletUrl,
                    data: data
                }, this.loadingIndicator);
            },
            fetchBillingMessageCount: function (prevMonth, month) {
                var url = '/servlets/chargify/customer/billingactivity/' + prevMonth + '/' + month + '/';
                return $enhancedHttp({
                    method: 'GET',
                    url: url
                }, this.loadingIndicator);
            },
            fetchBillingMessageCountSingleAccount: function (prevMonth, month, paymentUserName) {
                var url = '/servlets/chargify/customer/billingactivity/' + prevMonth + '/' + month + '/' + paymentUserName + '/';
                return $enhancedHttp({
                    method: 'GET',
                    url: url
                }, this.loadingIndicator);
            },
            updateSubscriptionTier: function (paymentUserName, id, data) {
                var url = "/servlets/chargify/subscriptiontier/" + paymentUserName + "/" + id + "/";
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    data: data
                }, this.loadingIndicator);
            },
            chargeAccount: function (paymentUserId, data) {
                var url = "/servlets/chargify/customer/billingmetereduser/" + paymentUserId + "/";
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    data: data
                }, this.loadingIndicator);
            },
            savePaymentUserName: function (userName, data) {
                var url = "/servlets/chargify/accountupdate/username/" + userName + "/";
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    data: data
                }, this.loadingIndicator);
            },
            subscriptionSave: function (customerId, data) {
                var servletUrl = "/servlets/chargify/customerupdate/id/" + customerId + "/";
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: servletUrl,
                    data: data
                }, this.loadingIndicator);
            },
            createNewUserAndSubscription: function (userName, data) {
                var servletUrl = "/servlets/chargify/subscrition/create/" + userName + "/";
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: servletUrl,
                    data: data
                }, this.loadingIndicator);
            },
            fetchZohoBillingAddress: function (userName) {
                var servletURL = "/servlets/zoho/customer/username/" + userName + "/";
                return $enhancedHttp({
                    method: 'GET',
                    url: servletURL
                }, this.loadingIndicator);
            }
        };
    }]);
//# sourceMappingURL=chargify.service.js.map